<template>
  <div class="mx-container">
    <div class="mycontainer">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <el-form-item label="部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 130px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 210px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmmc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="统计周期" prop="status">
          <!-- <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 220px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @keyup.enter.native="getList"
            :clearable="false"
          ></el-date-picker> -->
          <el-date-picker
            v-model="time[0]"
            style="width: 150px"
            type="date"
            placeholder="开始日期"
            :pickerOptions="pickerOptions"
            @change="onStartChange"
          >
          </el-date-picker>
          &nbsp; &nbsp;- &nbsp; &nbsp;
          <el-date-picker
            v-model="time[1]"
            style="width: 150px"
            type="date"
            placeholder="结束日期"
            :pickerOptions="pickerOptions"
            @change="onEndChange"
          >
          </el-date-picker>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        show-summary
        :summary-method="formatMoney"
      >
        <el-table-column
          label="分公司"
          prop="bmmc"
          min-width="100px"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="200px"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="回款金额"
          prop="money"
          :show-overflow-tooltip="true"
          min-width="80px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="款项所属周期"
          prop="period"
          min-width="150px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.period }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="付款方式"
          prop="receivable_cycle"
          min-width="80px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.receivable_cycle }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="付款日期"
          prop="receivable_time"
          min-width="120px"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.receivable_time }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
import { formatMomentDate } from "@/utils/utils";
import { getBmxx, getXmxx, hkListExport, getHkList } from "@/api/xmcbhs.js";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";

export default {
  name: "xmhkmx",
  computed: {
    ...mapGetters(["xmcbhsParams"]),
  },
  props: ["mxParams"],
  data() {
    return {
      height: 100,
      listQuery: {
        xmbh: "",
        bmbh: "",
        qsrq: "",
        jsrq: "",
      },
      bmList: [],
      xmList: [],
      time: [this.getCurrentMonthFirst(), Date.now()],
      list: [],
      listLoading: true,
    };
  },
  created() {
    this.listQuery.bmbh = this.mxParams.bmbh;
    this.listQuery.xmbh = Number(this.mxParams.xmbh);
    this.time = this.mxParams.time;
    // if (localStorage.getItem("xmcbhsTime")) {
    //   this.time = JSON.parse(localStorage.getItem("xmcbhsTime"));
    // }

    getBmxx().then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        if (this.bmList && this.bmList.length > 1) {
          this.bmList.unshift({ bmbh: "", bmmc: "全部" });
        }
        if (!this.listQuery.bmbh) {
          this.listQuery.bmbh = res.data[0].bmbh;
        }
        getXmxx(this.listQuery.bmbh, "").then((res2) => {
          if (res2.code == 0) {
            if (!this.listQuery.xmbh && res2.data && res2.data.length > 0) {
              this.listQuery.xmbh = res2.data[0].xmbh;
            }
            this.xmList = res2.data;
            localStorage.removeItem("xmcbhsBmbh");
            localStorage.removeItem("xmcbhsXmbh");
            localStorage.removeItem("xmcbhsTime");
            this.getList();
          }
        });
      }
    });
  },

  methods: {
    onStartChange(start) {
      // 开始日期晚于结束日期时，结束日期自动设置为开始日期
      const isAfter = moment(start).isAfter(this.time[1]);
      if (isAfter) {
        this.$set(this.time, 1, start);
      }
    },
    onEndChange(end) {
      // 结束日期早于开始日期时，开始日期自动设置为结束日期
      const isBefore = moment(end).isBefore(this.time[0]);
      if (isBefore) {
        // 赋值需要回显,需使用一下写法
        this.$set(this.time, 0, end);
        //错误写法
        // this.time[0] = end;
        // 语法
        // this.$set(原数组, 索引值, 需要赋的值);
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    getList() {
      if (!this.listQuery.xmbh) {
        this.$message.error("请选择查询的项目！");
        return;
      }
      this.listLoading = true;

      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = formatMomentDate(new Date(this.time[0]));
        this.listQuery.jsrq = formatMomentDate(new Date(this.time[1]));
      }

      getHkList(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 95;
        }
      });
    },
    getCurrentMonthFirst() {
      var date = new Date();
      date.setDate(1);
      return date;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeBm(e) {
      this.listQuery.bmbh = e;
      this.listQuery.xmbh = "";
      getXmxx(this.listQuery.bmbh, "").then((res4) => {
        if (res4.code == 0) {
          this.xmList = res4.data;
        }
      });
    },
    formatMoney(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (index == 4) {
            sums[index] = sums[index].toFixed(2);
          } else {
            sums[index] = this.formatWithMod("" + sums[index].toFixed(2));
          }
        }
      });

      return sums;
    },
    //导出
    handleExport() {
      const params = this.listQuery;
      hkListExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mx-container {
  padding: 0 20px 20px 20px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
</style>
